/* Varvensa Editorial: storefront interactions with Shopify native Ajax Cart & Search endpoints. */
(() => {
  'use strict';
  const settings = window.Varvensa || {};
  const root = String(settings.root || '/').replace(/\/?$/, '/');
  const url = path => root + path.replace(/^\//, '');
  const formatMoney = cents => {
    const curr = settings.currency || 'EUR';
    try { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: curr }).format((Number(cents) || 0) / 100); }
    catch { return `${((Number(cents) || 0) / 100).toFixed(2)} ${curr}`; }
  };
  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const safeImage = value => {
    if (!value) return '';
    const str = String(value);
    if (str.startsWith('//')) return `https:${str}`;
    if (/^https:\/\//i.test(str) || str.startsWith('/')) return str;
    return '';
  };
  const stickyHeader = document.querySelector('.ve-header--sticky');
  stickyHeader?.closest('.shopify-section')?.classList.add('ve-sticky-container');
  document.querySelector('.ve-header--overlay-home')?.closest('.shopify-section')?.classList.add('ve-header-overlay');
  // Transparent editorial header over the original cover; solid background after scrolling.
  const updateHeroHeader = () => {
    const header = document.querySelector('.ve-header--overlay-home');
    if (header) header.classList.toggle('ve-header--scrolled', window.scrollY > 45);
  };
  updateHeroHeader();
  window.addEventListener('scroll', updateHeroHeader, { passive: true });
  // Expandable dropdown menus remain functional for mouse, keyboard and touch.
  document.addEventListener('click', event => {
    const openMenus = document.querySelectorAll('.ve-desktop-nav [data-ve-menu-dropdown][open]');
    openMenus.forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('toggle', event => {
    const item = event.target;
    if (!item.matches?.('.ve-desktop-nav [data-ve-menu-dropdown]') || !item.open) return;
    document.querySelectorAll('.ve-desktop-nav [data-ve-menu-dropdown][open]').forEach(other => { if (other !== item) other.open = false; });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-ve-menu-dropdown][open]').forEach(item => {
        item.open = false;
        item.querySelector('summary')?.focus();
      });
    }
  });
  const cartDrawer = document.getElementById('ve-cart-drawer');
  const searchOverlay = document.getElementById('ve-search-overlay');
  const mobileMenu = document.getElementById('ve-mobile-menu');
  const shade = document.querySelector('[data-overlay-shade]');
  let activePanel = null;
  let panelReturnFocus = null;

  function closePanel() {
    if (!activePanel) return;
    activePanel.hidden = true;
    if (shade) shade.hidden = true;
    document.body.classList.remove('ve-lock');
    document.querySelectorAll('[aria-controls="' + activePanel.id + '"]').forEach(el => el.setAttribute('aria-expanded', 'false'));
    activePanel = null;
    if (panelReturnFocus?.isConnected) panelReturnFocus.focus();
  }
  function openPanel(panel, opener) {
    if (!panel) return;
    if (activePanel) closePanel();
    panelReturnFocus = opener || document.activeElement;
    panel.hidden = false;
    if (shade) shade.hidden = false;
    document.body.classList.add('ve-lock');
    activePanel = panel;
    document.querySelectorAll('[aria-controls="' + panel.id + '"]').forEach(el => el.setAttribute('aria-expanded', 'true'));
    const focusable = panel.querySelector('input,button,a,[tabindex="0"]');
    focusable?.focus();
  }
  document.addEventListener('click', event => {
    const btn = event.target.closest('[data-cart-open],[data-mobile-open],[data-search-open],[data-close-panel]');
    if (!btn) return;
    if (btn.matches('[data-close-panel]')) return closePanel();
    if (btn.matches('[data-cart-open]')) {
      openPanel(cartDrawer, btn);
      refreshCart();
    } else if (btn.matches('[data-mobile-open]')) openPanel(mobileMenu, btn);
    else if (btn.matches('[data-search-open]')) openPanel(searchOverlay, btn);
  });
  shade?.addEventListener('click', closePanel);
  document.addEventListener('keydown', event => {
    if (!activePanel) return;
    if (event.key === 'Escape') return closePanel();
    if (event.key !== 'Tab') return;
    const controls = [...activePanel.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex="0"]')].filter(el => el.offsetParent !== null);
    if (!controls.length) return;
    if (event.shiftKey && document.activeElement === controls[0]) { event.preventDefault(); controls.at(-1).focus(); }
    else if (!event.shiftKey && document.activeElement === controls.at(-1)) { event.preventDefault(); controls[0].focus(); }
  });

  async function getCart() {
    const response = await fetch(url('cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!response.ok) throw new Error('Impossibile aggiornare il carrello.');
    return response.json();
  }
  function renderCart(cart) {
    const count = cart.item_count || 0;
    document.querySelectorAll('[data-cart-count]').forEach(node => {node.textContent = count;node.hidden = !count;});
    document.querySelectorAll('[data-cart-drawer-count]').forEach(node => node.textContent = count ? `(${count})` : '');
    const body = document.querySelector('[data-cart-drawer-body]');
    const total = document.querySelector('[data-cart-drawer-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
    if (!body) return;
    const checkout = cartDrawer?.querySelector('.ve-cart-drawer__footer form button');
    if (checkout) checkout.disabled = !count;
    if (!count) { body.innerHTML = '<div class="ve-empty"><p>Il tuo carrello è vuoto.</p><p>Scopri i nostri mobili e trova quello che cerchi.</p></div>'; return; }
    body.innerHTML = (cart.items || []).map(item => {
      const photo = safeImage(item.image);
      const image = photo ? `<img src="${escapeHTML(photo)}" alt="" width="85" height="100" loading="lazy">` : '';
      const options = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="ve-small">${escapeHTML(item.variant_title)}</p>` : '';
      const itemProperties = item.properties && typeof item.properties === 'object' ? Object.entries(item.properties).filter(([k,v]) => k && !k.startsWith('_') && v != null && v !== '').map(([k,v]) => `<p class="ve-small">${escapeHTML(k)}: ${escapeHTML(v)}</p>`).join('') : '';
      return `<div class="ve-drawer-line"><a href="${escapeHTML(item.url)}">${image}</a><div class="ve-drawer-line__info"><a href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>${options}${itemProperties}<div class="ve-drawer-line__actions"><label class="ve-visually-hidden" for="ve-cart-${escapeHTML(item.key)}">Quantità</label><input id="ve-cart-${escapeHTML(item.key)}" type="number" min="0" step="1" value="${Number(item.quantity)}" data-cart-quantity data-key="${escapeHTML(item.key)}" aria-label="Quantità per ${escapeHTML(item.product_title)}"><button type="button" data-cart-remove data-key="${escapeHTML(item.key)}">Rimuovi</button></div></div><div class="ve-drawer-line__price">${formatMoney(item.final_line_price)}</div></div>`;
    }).join('');
  }
  async function refreshCart() {
    try { renderCart(await getCart()); }
    catch (error) { const body = document.querySelector('[data-cart-drawer-body]'); if (body) body.textContent = error.message || 'Errore di caricamento.'; }
  }
  async function changeCart(key, quantity) {
    const body = document.querySelector('[data-cart-drawer-body]');
    if (body) body.setAttribute('aria-busy','true');
    try {
      const response = await fetch(url('cart/change.js'), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Impossibile modificare la quantità.');
      renderCart(result);
    } catch (error) { alert(error.message || 'Si è verificato un problema.'); await refreshCart(); }
    finally { if (body) body.removeAttribute('aria-busy'); }
  }
  cartDrawer?.addEventListener('change', event => {
    const field = event.target.closest('[data-cart-quantity]');
    if (field) changeCart(field.dataset.key, Math.max(0, Math.floor(Number(field.value) || 0)));
  });
  cartDrawer?.addEventListener('click', event => {
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) changeCart(remove.dataset.key, 0);
  });

  // Product variant synchronization — Shopify variant JSON drives everything.
  document.querySelectorAll('[data-product-root]').forEach(rootNode => {
    const variantsJson = rootNode.querySelector('[data-product-variants]');
    if (!variantsJson) return;
    let variants = [];
    try { variants = JSON.parse(variantsJson.textContent); } catch { return; }
    const selector = rootNode.querySelector('[data-variant-select]');
    const hidden = rootNode.querySelector('[data-variant-input]');
    const price = rootNode.querySelector('[data-product-price]');
    const compare = rootNode.querySelector('[data-product-compare]');
    const available = rootNode.querySelector('[data-product-availability]');
    const button = rootNode.querySelector('[data-product-submit]');
    const buttonLabel = rootNode.querySelector('[data-product-submit-label]');
    const checkout = rootNode.querySelector('[data-dynamic-checkout]');
    const image = rootNode.querySelector('.ve-product-primary');
    const form = rootNode.querySelector('[data-product-form]');
    const errorBox = rootNode.querySelector('[data-product-error]');
    function selectedVariant() {
      const id = selector ? selector.value : hidden?.value;
      return variants.find(variant => String(variant.id) === String(id)) || variants[0];
    }
    function applyVariant() {
      const variant = selectedVariant();
      if (!variant) return;
      if (price) price.textContent = formatMoney(variant.price);
      if (compare) {
        const onSale = Number(variant.compare_at_price) > Number(variant.price);
        compare.hidden = !onSale;
        compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      }
      if (available) { available.textContent = variant.available ? 'Disponibile' : 'Esaurito'; if (variant.available) available.removeAttribute('data-unavailable'); else available.setAttribute('data-unavailable',''); }
      if (button) button.disabled = !variant.available;
      if (buttonLabel) buttonLabel.textContent = variant.available ? 'Aggiungi al carrello' : 'Esaurito';
      if (checkout) checkout.hidden = !variant.available;
      if (selector && image) {
        const selected = selector.selectedOptions[0];
        const picture = selected?.dataset.image || safeImage(variant.featured_image?.src);
        if (picture) { image.src = picture; image.removeAttribute('srcset'); image.alt = selected?.dataset.alt || image.alt; }
      }
      const nextURL = new URL(window.location.href);
      nextURL.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', nextURL);
    }
    selector?.addEventListener('change', applyVariant);
    rootNode.querySelectorAll('[data-product-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => { if (!image) return; image.src = thumb.dataset.image; image.removeAttribute('srcset'); image.alt = thumb.dataset.alt || image.alt; });
    });
    rootNode.querySelector('[data-qty-minus]')?.addEventListener('click', () => {const q = form.querySelector('[name="quantity"]'); q.value = Math.max(1, (parseInt(q.value,10) || 1) - 1);});
    rootNode.querySelector('[data-qty-plus]')?.addEventListener('click', () => {const q = form.querySelector('[name="quantity"]'); q.value = Math.max(1, (parseInt(q.value,10) || 1) + 1);});
    form?.addEventListener('submit', async event => {
      // Do not override accelerated checkout / wallet button submissions.
      if (event.submitter && !event.submitter.matches('[data-product-submit]')) return;
      event.preventDefault();
      if (!selectedVariant()?.available) return;
      button.disabled = true;
      if (buttonLabel) buttonLabel.textContent = 'Aggiunta in corso…';
      if (errorBox) { errorBox.hidden = true;errorBox.textContent = ''; }
      try {
        const response = await fetch(url('cart/add.js'), {method:'POST',credentials:'same-origin',headers:{'Accept':'application/json'},body:new FormData(form)});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Non è stato possibile aggiungere il prodotto.');
        await refreshCart();
        const cartOpener = document.querySelector('[data-cart-open]');
        openPanel(cartDrawer, cartOpener || button);
      } catch (error) {
        if (errorBox) { errorBox.hidden = false;errorBox.textContent = error.message || 'Impossibile aggiungere il prodotto.'; }
      } finally { button.disabled = !selectedVariant()?.available; if (buttonLabel) buttonLabel.textContent = selectedVariant()?.available ? 'Aggiungi al carrello' : 'Esaurito'; }
    });
    // Initial update: respect ?variant without requiring a reload.
    applyVariant();
  });

  // Native predictive search. A normal search GET form remains available without JavaScript.
  const searchField = document.querySelector('[data-suggest-input]');
  const suggestArea = document.getElementById('ve-suggest-results');
  let searchTimeout, searchAbort;
  searchField?.addEventListener('input', () => {
    clearTimeout(searchTimeout);
    searchAbort?.abort();
    const q = searchField.value.trim();
    if (!suggestArea) return;
    if (q.length < 2) { suggestArea.textContent = ''; searchField.setAttribute('aria-expanded','false'); return; }
    searchTimeout = setTimeout(async () => {
      searchAbort = new AbortController();
      const params = new URLSearchParams({q, 'resources[type]':'product','resources[limit]':'5'});
      try {
        const response = await fetch(url('search/suggest.json') + '?' + params.toString(), { signal: searchAbort.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Ricerca non disponibile');
        const json = await response.json();
        const products = json.resources?.results?.products || [];
        suggestArea.innerHTML = products.length ? `<div class="ve-suggest-list">${products.map(p => {
          const picture = safeImage(p.featured_image?.url);
          const thumb = picture ? `<img src="${escapeHTML(picture)}" alt="" loading="lazy">` : '';
          return `<a class="ve-suggest-item" href="${escapeHTML(p.url)}">${thumb}<span><strong>${escapeHTML(p.title)}</strong></span></a>`;
        }).join('')}</div>` : '<p class="ve-small">Nessun prodotto trovato.</p>';
        searchField.setAttribute('aria-expanded',products.length ? 'true' : 'false');
      } catch (error) { if (error.name !== 'AbortError') suggestArea.textContent = ''; }
    }, 260);
  });

  document.querySelectorAll('[data-auto-sort]').forEach(form => form.querySelector('select')?.addEventListener('change', () => form.requestSubmit()));
  // Shopify product recommendations through the standard Section Rendering endpoint.
  document.querySelectorAll('product-recommendations[data-recommendations-url]').forEach(async node => {
    if (node.querySelector('.ve-product-grid')) return;
    try {
      const response = await fetch(node.dataset.recommendationsUrl, {credentials:'same-origin'});
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const loaded = doc.querySelector('product-recommendations');
      if (loaded?.querySelector('.ve-product-grid')) node.innerHTML = loaded.innerHTML;
    } catch { /* recommendations are optional; leave empty when unavailable */ }
  });
})();
